module.exports = __webpack_public_path__ + "img/login-logo.f7a92916.png";